import { render, staticRenderFns } from "./PrintingThroughputReport.vue?vue&type=template&id=1c50356a"
import script from "./PrintingThroughputReport.vue?vue&type=script&lang=js"
export * from "./PrintingThroughputReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports